import React from 'react';
import StyledComponent from '../../core/StyledComponent';
import Modal, { ModalProps } from '../components/modal/Modal';
import { px2rem } from '../../core';
import { useTheme } from '@mui/material';

interface Link {
    name: string;
    url: string;
}

const LinkList: Link[] = [
    {
        name: 'Terms & Conditions',
        url: 'https://www.menuzen.com/site-terms-conditions',
    },
    {
        name: 'Privacy Policy',
        url: 'https://www.menuzen.com/site-privacy-policy',
    },
    {
        name: 'Claim Menuzen.site Page',
        url: 'https://www.menuzen.com/claim-report',
    },
    {
        name: 'Request To Remove Or Report ',
        url: 'https://www.menuzen.com/claim-report',
    },
];

const ToSModal: React.FC<ModalProps> = (props) => {
    const theme = useTheme();

    return (
        <Modal
            {...props}
            xs={{
                padding: px2rem(20),
                borderRadius: `${px2rem(10)}`,
                backgroundColor: 'white',
                fontFamily: theme.typography.fontFamily,
                color: theme.palette.primary.main,
            }}
            sm={{
                minWidth: 450,
            }}
        >
            <StyledComponent
                xs={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {LinkList.map((item, idx) => (
                    <StyledComponent
                        as={'a'}
                        key={idx}
                        href={item.url}
                        xs={{
                            width: '100%',
                            paddingTop: 18,
                            paddingBottom: 18,
                            paddingLeft: 10,
                            paddingRight: 10,
                            fontSize: 18,
                            lineHeight: 'none',
                        }}
                    >
                        {item.name}
                    </StyledComponent>
                ))}
            </StyledComponent>
        </Modal>
    );
};

export default ToSModal;
